import { render, staticRenderFns } from "./leaderUserLookupModal.vue?vue&type=template&id=0fd2b2b2&"
import script from "./leaderUserLookupModal.vue?vue&type=script&lang=js&"
export * from "./leaderUserLookupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports